import React, { useState, useEffect } from 'react';
import AuthService from '../services/authService';
import { AuthState } from '../types';

interface LoginProps {
  onLogin: () => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [authState, setAuthState] = useState<AuthState>(AuthService.getInstance().getAuthState());

  useEffect(() => {
    const authService = AuthService.getInstance();
    const unsubscribe = authService.subscribe(setAuthState);
    
    // Check if user is already authenticated
    if (authService.isLoggedIn()) {
      onLogin();
    }

    return unsubscribe;
  }, [onLogin]);

  const handleGoogleLogin = async () => {
    try {
      await AuthService.getInstance().loginWithGoogle();
      onLogin();
    } catch (error) {
      console.error('Google login failed:', error);
    }
  };

  if (authState.isAuthenticated) {
    return null; // Component will be hidden when authenticated
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>🏁 Race Series Points Manager</h1>
          <p>Sign in to manage your racing series data</p>
        </div>

        {authState.error && (
          <div className="error-message">
            <span>⚠️ {authState.error}</span>
          </div>
        )}

        <div className="login-methods">
          {/* Google OAuth */}
          <div className="oauth-section">
            <button 
              className="oauth-button google-button"
              onClick={handleGoogleLogin}
              disabled={authState.isLoading}
            >
              <span className="oauth-icon">🔍</span>
              Continue with Google
            </button>
          </div>
        </div>

        {/* Demo Notice - only show in demo mode */}
        {AuthService.getInstance().isDemoMode() && (
          <div className="demo-notice">
            <p><strong>Demo Mode:</strong> OAuth provider is simulated. In production, this would integrate with real Google OAuth service.</p>
          </div>
        )}
      </div>

      {authState.isLoading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <p>Signing you in...</p>
        </div>
      )}
    </div>
  );
};

export default Login; 